import { logOut } from "../modules/auth/slices/authSlice";
import { useAppDispatch } from "../app/hook";

function useAuthorizationError() {
  const dispatch = useAppDispatch();

  const logoutUser = (errCode: number) => {
    if (errCode === 401) {
      dispatch(logOut());
    }
  };

  return [logoutUser];
}

export default useAuthorizationError;
